import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { UIFieldSetModel, UIWorkFieldModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-field-set-bootstrap',
  templateUrl: './e5core-ui-work-field-set-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-set-bootstrap.component.css']
})
export class E5coreUiWorkFieldSetBootstrapComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() fieldSet: UIFieldSetModel ;
  @Input() fields: UIWorkFieldModel[] ;
  @Input() readonly: boolean;

  constructor() { }

  ngOnInit() {
  }

}
